import { Checkbox } from '@material-ui/core';
import currencyFormatter from 'currency-formatter';
import { WithStyles } from 'decorators/withStyles';
import React, { PureComponent } from 'react';

interface IProps {
  classes?: any;
  description?: string;
  price?: number;
  image?: string;
}

interface IState {}

@WithStyles(() => ({
  container: {
    width: '425px'
  },
  title: {
    color: '#596375',
    width: '383px',
    '& p': {
      margin: 0
    }
  },
  preview: {
    border: '3px dashed #009358',
    fontFamily: 'Lato',
    padding: '4px',
    width: '320px',
    marginTop: '15px',
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'wrap',
    color: '#596375',
    '& p': {
      margin: 0,
      fontSize: '14px'
    },
    '& span': {
      color: '#009358',
      fontSize: '16px',
      fontWeight: 'bold'
    }
  },
  containerText: {
    width: '230px'
  },
  imagemProduct: {
    height: '70px',
    width: '70px',
    borderRadius: '4px',
    '& img': {
      width: '100%',
      height: '100%'
    }
  },
  footerPreview: {
    backgroundColor: '#009358',
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: '0 8px',
    height: '25px',
    width: '320px',
    alignItems: 'center',
    '& p': {
      fontSize: '0.785rem',
      color: '#fff'
    },
    '& span': {
      padding: 0,
      color: '#fff'
    }
  }
}))
export default class PreviewOrderBump extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, description, price, image } = this.props;

    if (price == null) return null;

    return (
      <div className={classes.container}>
        <div className={classes.title}>Preview do Order Bump</div>
        <div className={classes.preview}>
          <div className={classes.imagemProduct}>
            <img style={{ borderRadius: '4px' }} src={image} />
          </div>
          <div className={classes.containerText}>
            <span>Oferta Imperdível</span>
            <p>
              {`Adquira também por apenas `}
              <span>{currencyFormatter.format(price, { code: 'BRL', precision: 2 })}</span>
              {` ${!description ? '' : description}`}
            </p>
          </div>
        </div>
        <div className={classes.footerPreview}>
          <Checkbox />
          <p>Sim, quero adicionar esta oferta em minha compra</p>
        </div>
      </div>
    );
  }
}
